module.exports = __webpack_public_path__ + "img/404.e7af79dc.png";